// extracted by mini-css-extract-plugin
export var content = "_cf-3";
export var list = "_cf-4";
export var settingsContent = "_cf-7";
export var settingsPanel = "_cf-8";
export var state = "_cf-6";
export var triggerBadge = "_cf-2";
export var triggerButton = "_cf-1";
export var triggerShell = "_cf-0";
export var unreadDot = "_cf-5";